import store from "@/state/store";

export default [
    {
        path: "/login",
        name: "login",
        component: () => import("../views/account/login.vue"),
        meta: {
            title: "Login",
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({ name: "default" });
                    // next();
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/register",
        name: "Register",
        component: () => import("../views/account/register.vue"),
        meta: {
            title: "Register",
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({ name: "default" });
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/forgot-password",
        name: "Forgot password",
        component: () => import("../views/account/forgot-password.vue"),
        meta: {
            title: "Forgot Password",
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({ name: "default" });
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/logout",
        name: "logout",
        meta: {
          title: "Logout", authRequired: true,
          beforeResolve(routeTo, routeFrom, next) {
            localStorage.clear();
            sessionStorage.clear();
            next();
          },
        },
        component: () => import("../views/auth/logout/basic.vue")
      },
    // Components
    {
        path: "/",
        name: "dashboard",
        meta: { title: "Dashboard" },
        component: () => import("../views/dashboard/index.vue"),
    },

    // Authentication
    {
        path: "/auth/signin-basic",
        name: "signin-basic",
        meta: { title: "Sign In" },
        component: () => import("../views/auth/signin/basic.vue"),
    },
    {
        path: "/auth/signin-basic-2",
        name: "signin-basic-2",
        meta: { title: "Sign In" },
        component: () => import("../views/auth/signin/basic-2.vue"),
    },
    {
        path: "/auth/signin-cover",
        name: "signin-cover",
        meta: { title: "Sign In" },
        component: () => import("../views/auth/signin/cover.vue"),
    },
    {
        path: "/auth/signup-basic",
        name: "signup-basic",
        meta: { title: "Sign Up" },
        component: () => import("../views/auth/signup/basic.vue"),
    },
    {
        path: "/auth/signup-basic-2",
        name: "signup-basic-2",
        meta: { title: "Sign Up" },
        component: () => import("../views/auth/signup/basic-2.vue"),
    },
    {
        path: "/auth/signup-cover",
        name: "signup-cover",
        meta: { title: "Sign Up" },
        component: () => import("../views/auth/signup/cover.vue"),
    },
    {
        path: "/auth/pass-reset-basic",
        name: "pass-reset-basic",
        meta: { title: "Reset Password" },
        component: () => import("../views/auth/reset/basic.vue"),
    },
    {
        path: "/auth/pass-reset-basic-2",
        name: "pass-reset-basic-2",
        meta: { title: "Reset Password" },
        component: () => import("../views/auth/reset/basic-2.vue"),
    },
    {
        path: "/auth/pass-reset-cover",
        name: "pass-reset-cover",
        meta: { title: "Reset Password" },
        component: () => import("../views/auth/reset/cover.vue"),
    },
    {
        path: "/auth/pass-change-basic",
        name: "pass-change-basic",
        meta: { title: "Create New Password" },
        component: () => import("../views/auth/create/basic.vue"),
    },
    {
        path: "/auth/pass-change-basic-2",
        name: "pass-change-basic-2",
        meta: { title: "Create New Password" },
        component: () => import("../views/auth/create/basic-2.vue"),
    },
    {
        path: "/auth/pass-change-cover",
        name: "pass-change-cover",
        meta: { title: "Create New Password" },
        component: () => import("../views/auth/create/cover.vue"),
    },
    {
        path: "/auth/lockscreen-basic",
        name: "lockscreen-basic",
        meta: { title: "Lock Screen" },
        component: () => import("../views/auth/lockscreen/basic.vue"),
    },
    {
        path: "/auth/lockscreen-basic-2",
        name: "lockscreen-basic-2",
        meta: { title: "Lock Screen" },
        component: () => import("../views/auth/lockscreen/basic-2.vue"),
    },
    {
        path: "/auth/lockscreen-cover",
        name: "lockscreen-cover",
        meta: { title: "Lock Screen" },
        component: () => import("../views/auth/lockscreen/cover.vue"),
    },
    {
        path: "/auth/logout-basic",
        name: "logout-basic",
        meta: { title: "Log Out" },
        component: () => import("../views/auth/logout/basic.vue"),
    },
    {
        path: "/auth/logout-basic-2",
        name: "logout-basic-2",
        meta: { title: "Log Out" },
        component: () => import("../views/auth/logout/basic-2.vue"),
    },
    {
        path: "/auth/logout-cover",
        name: "logout-cover",
        meta: { title: "Log Out" },
        component: () => import("../views/auth/logout/cover.vue"),
    },
    {
        path: "/auth/success-msg-basic",
        name: "success-msg-basic",
        meta: { title: "Success Message" },
        component: () => import("../views/auth/success-msg/basic.vue"),
    },
    {
        path: "/auth/success-msg-basic-2",
        name: "success-msg-basic-2",
        meta: { title: "Success Message" },
        component: () => import("../views/auth/success-msg/basic-2.vue"),
    },
    {
        path: "/auth/success-msg-cover",
        name: "success-msg-cover",
        meta: { title: "Success Message" },
        component: () => import("../views/auth/success-msg/cover.vue"),
    },
    {
        path: "/auth/twostep-basic",
        name: "twostep-basic",
        meta: { title: "Two Step Verification" },
        component: () => import("../views/auth/two-step/basic.vue"),
    },
    {
        path: "/auth/twostep-basic-2",
        name: "twostep-basic-2",
        meta: { title: "Two Step Verification" },
        component: () => import("../views/auth/two-step/basic-2.vue"),
    },
    {
        path: "/auth/twostep-cover",
        name: "twostep-cover",
        meta: { title: "Two Step Verification" },
        component: () => import("../views/auth/two-step/cover.vue"),
    },
    {
        path: "/auth/404-basic",
        name: "404-basic",
        meta: { title: "404 Error Basic" },
        component: () => import("../views/auth/error/404-basic.vue"),
    },
    {
        path: "/auth/404-cover",
        name: "404-cover",
        meta: { title: "404 Error Cover" },
        component: () => import("../views/auth/error/404-cover.vue"),
    },
    {
        path: "/auth/404-alt",
        name: "404-alt",
        meta: { title: "404 Error Alt" },
        component: () => import("../views/auth/error/404-alt.vue"),
    },
    {
        path: "/auth/500",
        name: "500",
        meta: { title: "500 Error" },
        component: () => import("../views/auth/error/500.vue"),
    },
    {
        path: "/auth/offline",
        name: "offline",
        meta: { title: "Offline Page" },
        component: () => import("../views/auth/error/offline.vue"),
    },

    // Pages
    {
        path: "/pages/starter",
        name: "starter",
        meta: { title: "Starter" },
        component: () => import("../views/pages/starter.vue"),
    },
    {
        path: "/pages/profile",
        name: "profile",
        meta: { title: "Profile" },
        component: () => import("../views/pages/profile/simplePage.vue"),
    },
    {
        path: "/pages/profile-settings",
        name: "profile-settings",
        meta: { title: "Profile Settings" },
        component: () => import("../views/pages/profile/setting.vue"),
    },
    {
        path: "/pages/team",
        name: "team",
        meta: { title: "Team" },
        component: () => import("../views/pages/team.vue"),
    },
    {
        path: "/pages/timeline",
        name: "timeline",
        meta: { title: "Timeline" },
        component: () => import("../views/pages/timeline.vue"),
    },
    {
        path: "/pages/faqs",
        name: "faqs",
        meta: { title: "FAQs" },
        component: () => import("../views/pages/faqs.vue"),
    },
    {
        path: "/pages/pricing",
        name: "pricing",
        meta: { title: "Pricing" },
        component: () => import("../views/pages/pricing.vue"),
    },
    {
        path: "/pages/maintenance",
        name: "maintenance",
        meta: { title: "Maintenance" },
        component: () => import("../views/pages/maintenance.vue"),
    },
    {
        path: "/pages/coming-soon",
        name: "coming-soon",
        meta: { title: "Coming Soon" },
        component: () => import("../views/pages/coming-soon.vue"),
    },
    {
        path: "/pages/sitemap",
        name: "sitemap",
        meta: { title: "Sitemap" },
        component: () => import("../views/pages/sitemap.vue"),
    },
    {
        path: "/pages/search-results",
        name: "search-results",
        meta: { title: "Search Results" },
        component: () => import("../views/pages/search-result.vue"),
    },

    // Widget
    {
        path: "/widgets",
        name: "widgets",
        meta: { title: "Widgets" },
        component: () => import("../views/widget/index.vue"),
    },

    // Apps
    {
        path: "/apps/calendar",
        name: "calendar",
        meta: { title: "Calendar" },
        component: () => import("../views/apps/calendar/main.vue"),
    },
    {
        path: "/apps/api-key",
        name: "api-key",
        meta: { title: "API Key" },
        component: () => import("../views/apps/apikey.vue"),
    },
    {
        path: "/apps/contact",
        name: "contact",
        meta: { title: "Contact" },
        component: () => import("../views/apps/contacts.vue"),
    },
    {
        path: "/apps/leaderboards",
        name: "leaderboards",
        meta: { title: "Leaderboard" },
        component: () => import("../views/apps/leaderboards/index.vue"),
    },
]